import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { GoLinkExternal } from "react-icons/go";
import { encrypt, decrypt } from "../../Utils/Encryption";
import { StoreContext } from "../../store/Store";
import Loader from "../Loader/Loader";
import DashboardBarChart from "../../charts/DashboardBarChart";
import DashboardPieChart from "../../charts/DashboardPieChart";
import DashboardDonutChart from "../../charts/DashboardDonutChart";
import DashboardLineChart from "../../charts/DashboardLineChart";
import { FaGreaterThan } from "react-icons/fa";

const ChildDashboardChartComponent = () => {
  const {
    getChildMetrics,
    childMetrics,
    database,
    getMetricKPI,
    metricKPI,
    setActiveNavbar,
    activeNavbar,
  } = useContext(StoreContext);
  const [breadcrumps, setBreadcrumps] = useState([]);
  const { metricname, metricid, status } = useParams();
  const decodedMetricId = decrypt(metricid);

  setActiveNavbar(decodedMetricId);

  useEffect(() => {
    const configid = localStorage.getItem("configid");
    getMetricKPI(configid, decodedMetricId);
  }, [metricid]);

  useEffect(() => {
    setBreadcrumps((prev) => {
      const existingIndex = prev.findIndex(
        (item) => item.metric_id === metricid
      );

      if (existingIndex !== -1) {
        return prev.slice(0, existingIndex + 1);
      } else {
        return [
          ...prev,
          {
            metric_id: metricid,
            metric_name: metricname,
          },
        ];
      }
    });
  }, [metricid, metricname]);

  useEffect(() => {
    const configid = localStorage.getItem("configid");
    getChildMetrics(configid, decodedMetricId);
  }, [metricid]);

  const renderChart = (chartType, metricData, i) => {
    switch (chartType) {
      case "Bar Chart":
        return (
          <DashboardBarChart key={i} metricData={metricData} status={status} />
        );
      case "Pie Chart":
        return (
          <DashboardPieChart key={i} metricData={metricData} status={status} />
        );
      case "Donut Chart":
        return (
          <DashboardDonutChart
            key={i}
            metricData={metricData}
            status={status}
          />
        );
      case "Line Chart":
        return (
          <DashboardLineChart key={i} metricData={metricData} status={status} />
        );
      default:
        return <p key={i}>No chart type found for {chartType}</p>;
    }
  };

  console.log(childMetrics);

  console.log("database", database, "childmetrics", childMetrics)

  if (database == null || childMetrics == null) {
    return <Loader />;
  }

  return (
    <div>
      <div className="dashboard">
        <div
          className={`breadcrumps d-flex ${
            status == 1 ? "justify-content-end" : "justify-content-start"
          } `}
        >
          {status == 1 &&
            breadcrumps.map((item, i) => (
              <div className="breadcrump d-flex" key={i}>
                <span className="mb-0 badge text-md fw-medium px-20 py-9 radius-4 text-secondary">
                  {item.metric_name}
                </span>
                {i < breadcrumps.length - 1 && (
                  <span className=" text-lg "> {">"} </span>
                )}
              </div>
            ))}

          {status == 0 && (
            <p className="mb-0 badge text-lg fw-medium px-20 py-9 radius-4 text-secondary">
              {metricname}
            </p>
          )}
        </div>
        <div className="row gy-3 gx-3 mt-1 mb-3">
          {/* SalesStatisticOne */}
          {/* <SalesStatisticOne /> */}
          {metricKPI.map((item, index) =>
            item.chart_type === "Line Chart" ? (
              <div className="col-12 col-md-4">
                <DashboardLineChart metricData={item} />
              </div>
            ) : null
          )}

          {/* TotalSubscriberOne */}
          {/* <TotalSubscriberOne /> */}
          {metricKPI.map((item, index) =>
            item.chart_type === "Bar Chart" ? (
              <div className="col-12 col-md-4">
                <DashboardBarChart metricData={item} />
              </div>
            ) : null
          )}

          {/* UsersOverviewOne */}
          {/* <UsersOverviewOne /> */}
          {metricKPI.map((item, index) =>
            item.chart_type === "Pie Chart" ? (
              <div className="col-12 col-md-4">
                <DashboardPieChart metricData={item} />
              </div>
            ) : null
          )}
        </div>
        <div className="level0Metrics row g-3">
          {childMetrics
            .filter(
              (filterItem) =>
                filterItem.value && Object.keys(filterItem.value).length > 0
            )
            .map((item, i) => (
              <div className="level0Metric col-12 col-md-6" key={i}>
                {renderChart(item.chart_type, item, i)}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ChildDashboardChartComponent;
